import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import '@purple/semantic-ui-purple-theme/components/popup.css';

export default Popup;
